module.exports = __webpack_public_path__ + "img/xsd_icon.48f8d20a.svg";